<template>

<app-view-sheet-field align="center" :is-sticky="isSticky" :field="field" :filter="filter">

	<span v-html="formatcurrency(value)" v-if="value" />

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky'],

	computed: {

		value: function() {

			if (this.item.user.plays) {

				return (this.item.game.version) ? this.item.game.version.worth.value  / this.item.user.plays : this.item.game.worth.value / this.item.user.plays

			} else {

				return 0

			}

		}

	}

}

</script>

<style scoped>

</style>